module.exports = __webpack_public_path__ + "img/user_document.ee858d0a.svg";